var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsMutualMatch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "66px",
    height: "62px",
    viewBox: "0 0 66 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons-MutualMatch@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-19.7%",
    y: "-21.9%",
    width: "139.3%",
    height: "143.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M3.73382284,4.01470037 C-1.24745918,9.36511901 -1.24175524,17.954293 3.73382284,23.3089452 L24.0508333,45.1780785 C24.2503639,45.3945786 24.5279202,45.5172414 24.8182773,45.5172414 C25.1086343,45.5172414 25.3861906,45.3945786 25.5857212,45.1780785 C32.3645366,37.8968418 39.1403426,30.6073113 45.9192108,23.3259119 C50.900493,17.9754012 50.900493,9.3821454 45.9192108,4.03164004 C40.9379814,-1.3188599 32.7951312,-1.31897916 27.813849,4.03164004 L24.8265163,7.23323654 L21.8392363,4.01470037 C19.3485689,1.33944769 16.0573957,0 12.7782642,0 C9.49913264,0 6.22443752,1.33944227 3.73382284,4.01470037 Z",
    id: "path-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Matches-guest-upgrade-with-statement-Copy",
    transform: "translate(-155.000000, -298.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(39.000000, 230.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-MutualMatch",
    filter: "url(#filter-1)",
    transform: "translate(124.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/mid-grey",
    transform: "translate(0.172414, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    fill: "#A5A5A5",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.137931, -1.379310)",
    id: "colour/mid-grey"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "colour/primary-green",
    fill: "#7BCB45",
    points: "0 0 56.5517241 0 56.5517241 49.6551724 0 49.6551724"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsMutualMatch);
export default __webpack_public_path__ + "static/media/Icons-MutualMatch@.672eab2e7fefd4ef04b3ea3ab9fbdf15.svg";
export { ForwardRef as ReactComponent };